import script from "./form-drawer-4.vue?vue&type=script&lang=ts&setup=true"
export * from "./form-drawer-4.vue?vue&type=script&lang=ts&setup=true"

import "./form-drawer-4.vue?vue&type=style&index=0&id=52af3abd&lang=scss&scoped=true"

import exportComponent from "D:\\Projects\\WebStorm\\tianshu-platform\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-52af3abd"]])

export default __exports__